var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"appear":"","name":"fade"}},[_c('div',{staticClass:"loading-spinner-block",attrs:{"id":"loader"}},[_c('v-progress-circular',{attrs:{"color":"white","indeterminate":"","size":"100","width":10}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }